import type { IconViewBox } from './icon.types';
import { JOYKIT_ICONS, IconSVG24 } from './iconDefinitions';

export type { IconViewBox, ComposeableIcon, BundledIcon, IconConfig } from './icon.types';

const generateViewBoxStringFromValue = (viewBox: IconViewBox) => `0 0 ${viewBox} ${viewBox}`;

export { JOYKIT_ICONS, generateViewBoxStringFromValue, IconSVG24 };
